import { HTMLAttributes, forwardRef } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
	padding?: 'none' | 'sm' | 'md' | 'lg';
	hover?: boolean;
}

const Card = forwardRef<HTMLDivElement, CardProps>(
	({ padding = 'md', hover = false, className = '', children, ...props }, ref) => {
		const paddingClasses = {
			none: '',
			sm: 'p-4',
			md: 'p-[18px]',
			lg: 'p-8',
		};

		const cardClasses = hover ? 'card-hover' : 'shadow-card';

		return (
			<div
				ref={ref}
				className={`bg-panel dark:bg-gray-800 rounded-xl ${cardClasses} ${paddingClasses[padding]} ${className}`}
				{...props}
			>
				{children}
			</div>
		);
	},
);

Card.displayName = 'Card';

export default Card;
